import loadable from '@loadable/component';
import ChannelComponentWrapper from './ChannelComponentWrapper';
import { CHANNEL } from 'domains/landing-autos/enums/channel';

const BCPMainComponent = loadable(
  () => import('../domains/auto-efectivo/containers/app-new'),
);
const DefaultMainComponent = loadable(
  () => import('../domains/landing-autos/containers/app/app'),
);

const channelComponentMap = {
  [CHANNEL.BCP_AUTOEFECTIVO]: BCPMainComponent,
};

const MainPageWrapper = () => (
  <ChannelComponentWrapper
    channelComponentMap={channelComponentMap}
    defaultComponent={DefaultMainComponent}
  />
);

export default MainPageWrapper;
